import { createRequest } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import * as modern from "./modern"

const addToFleetModern = createRequest<modern.AddToFleetModernInput, Readonly<{ id: string }>>(
  async (input, getToken) => modern.addToFleet(input, getToken)
)

export const useAddToFleetModern = createRequestHook(addToFleetModern)
